
import { Component, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import TitlePage from '@/components/atoms/TitlePage.vue'

/**
 * ページタイトルパネル
 */
@Component({
  components: {
    PanelFrame,
    TitlePage,
  },
})
export default class TitlePanel extends Vue {}
